import Vue from 'vue';
import {
  ValidationProvider, ValidationObserver, extend, configure
} from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';

Object.keys(rules).forEach((rule) => {
  extend(rule, rules[rule]);
});

// Add custom rules
extend('positive', (value) => value >= 0);

const config = {
  classes: {
    invalid: 'is-invalid'
  },
};

configure(config);

// Register it globally
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
